export * from './domain';
export * from './testkit';
export * from './builders';
export * from './dto';
export var createEmailDashboardApi = function (baseUrl, http) {
    var url = baseUrl + "/dashboard/ticketing";
    return {
        getTableData: function (emailDashboardDto) { return http.post("" + url, emailDashboardDto); },
        getDashboardOverview: function (emailDashboardOverviewDto) { return http.post(url + "/overview", emailDashboardOverviewDto); },
    };
};
//# sourceMappingURL=index.js.map